module.exports = __webpack_public_path__ + "img/yinhao.ee6d19bf.png";